import { Stack, styled } from '@mui/material';

export const IconContainer = styled(Stack)(({ theme }) => ({
  justifyContent: 'center',
  alignItems: 'center',
  height: 48,
  width: 48,
  backgroundColor: theme.palette.primary.main,
  borderRadius: '50%',
}));
